import React from 'react';
import Toaster from 'toastr';
import SubHeader from '../../../common/subHeader';
import Divider from '../../../common/divider';
import ATable from '../../../common/table';
import Messages from '../../../../configurations/messages';
import DisputesApi from '../../../../api/DisputesApi';


const settlementTableColumns = [
    {
        expander: true,
        header: "",
        accessor: "reference",
    },
    {
        expander: true,
        header: "Setttlement Reference",
        accessor: "reference",
        render :  row => {return row.row.reference;},
        width: 250,
    },
    {
        expander: true,
        header: "Settlement Type",
        accessor: "type",
        render :  row => {return row.row.type;},
        width: 300,
    },

    {
        expander: true,
        header: "Settlement Date",
        accessor: "date",
        render :  row => {return row.row.date;},
        width: 250,
    },
    

];

const settlementDetailsTableColumns = [
    {
        header: "Participant",
        accessor: "participant",
    },
    {
        header: "Role",
        accessor: "role",
    },

    {
        header: "Institution",
        accessor: "settlementInstitution",
    },

    {
        header: "Amount",
        accessor: "amount",
    },

    {
        header: "Currency",
        accessor: "currency",
    }
]


class DisputeModalSettlementSection extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onRowClick = this.onRowClick.bind(this);
        this.state = {
            showSettlement : false,
            settlements: [],
            loadingSettlements: false
        }
        this.onShowSettlement = this.onShowSettlement.bind(this);
    }

    onRowClick(state) {

    }

    onShowSettlement(event) {
        this.setState({ showSettlement: true, loadingSettlements : true });
        DisputesApi
            .getDisputeSettlements(this.props.logCode)
            .then((response => {
                this.setState({loadingSettlements : false, settlements : response.data});
            }))
            .catch(error => {
                console.log(error);
                Toaster.error(error.statusText, `${error.status} - ${Messages.ERROR_DISPUTE_SETTLEMENTS_TITLE} `);
                this.setState({loadingSettlements : false});
            })
        
    }
    render() {
        return (
            <div>
                <Divider />
                <SubHeader title="Settlements" />
                <Divider />
                {!this.state.showSettlement && 
                    <div className="row">
                        <div className="col-md-12" style={{ textAlign: "center" }} >
                            <button className="btn btn-large btn-primary"  onClick={this.onShowSettlement}>View Settlements</button>
                        </div>
                        
                    </div>
                }

                {this.state.showSettlement && <ATable
                    className="-striped -highlight"
                    tableData={this.state.settlements}
                    columns={settlementTableColumns}
                    loading={this.state.loadingSettlements}
                    onRowClick={this.onRowClick}
                    defaultPageSize={5}
                    SubComponent={(rowObject) => {
                        return (
                            <div style={{ textAlign: "center" }}>
                                <ATable 
                                    className="-striped -highlight"
                                    tableData={rowObject.row.settlements}
                                    columns={settlementDetailsTableColumns}
                                    defaultPageSize={5}
                                />
                            </div>
                        )
                    }}
                />}


            </div>
        )
    }
}
export default DisputeModalSettlementSection;





// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModalSettlementSection.js